import * as React from "react"

const LoanIcon = (props) => (
  <svg
    width={23}
    height={21}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.82 13.17c-1.216-1.03-2.706-.63-3.453-.07l-2.358 1.777h-.132c.029-1.481-1.159-2.65-2.666-2.65H7.586c-1.11 0-2.204.368-3.07 1.032l-1.11.85H1.23a.938.938 0 0 0-.937.935.94.94 0 0 0 .937.937l2.813-.002 1.611-1.227a3.179 3.179 0 0 1 1.934-.645h5.625c1.09 0 1.133 1.572-.044 1.572h-2.337a.538.538 0 0 0 0 1.079h5.258c.379 0 .748-.124 1.051-.352l2.393-1.8c.322-.24.8-.26 1.109 0a.753.753 0 0 1-.035 1.2l-3.93 2.947c-.302.225-.669.352-1.05.352H1.23a.937.937 0 1 0 0 1.873h14.406a3.58 3.58 0 0 0 2.159-.723l3.937-2.962a2.633 2.633 0 0 0 1.06-2.03 2.564 2.564 0 0 0-.972-2.094ZM11.203 7.813c-.297-.043-.688-.184-1.031-.309L9.98 7.44c-.488-.172-1.023.082-1.195.535a.944.944 0 0 0 .535 1.23l.182.065c.33.12.699.238 1.07.325v.446a.938.938 0 0 0 1.874 0v-.406c.987-.223 1.675-.853 1.8-1.786.34-1.955-1.52-2.487-2.516-2.771l-.172-.072c-.992-.291-.969-.417-.941-.578.045-.264.6-.393 1.258-.288.193.03.445.1.768.211a.937.937 0 1 0 .612-1.772 7.399 7.399 0 0 0-.774-.223v-.44a.938.938 0 0 0-1.874 0v.411c-.986.223-1.678.85-1.873 1.782-.3 1.932 1.586 2.487 2.297 2.698l.254.073c1.235.354 1.216.465 1.185.65-.045.261-.6.39-1.267.285Z"
      fill= {props.color ?  props.color:"#5A5A5C"}
    />
  </svg>
)

export default LoanIcon
